export const CAREER_CLUSTER_FILTER_KEYS = {
  nonFilterKey: 'careerClusterInterestList',
  nonFilterKeyAnd: 'careerClusterInterestListAnd',
  favoriteOnlyKey: 'careerClusterFavorite',
  favoriteOnlyKeyAnd: 'careerClusterFavoriteAnd',
  favoriteConditionKey: 'isFavoriteCareerClusterInterest',
  goalOnlyKey: 'careerClusterGoal',
  goalOnlyKeyAnd: 'careerClusterGoal',
  goalConditionKey: 'goalCareerClusterInterest',
  combinedKey: 'careerClusterAnyInterest',
  combinedKeyAnd: 'careerClusterAnyInterestAnd',
};

export const CAREER_FILTER_KEYS = {
  nonFilterKey: 'careerInterestList',
  nonFilterKeyAnd: 'careerInterestListAnd',
  favoriteOnlyKey: 'careerFavorite',
  favoriteOnlyKeyAnd: 'careerFavoriteAnd',
  favoriteConditionKey: 'isFavoriteCareerInterest',
  goalOnlyKey: 'careerGoal',
  goalOnlyKeyAnd: 'careerGoal',
  goalConditionKey: 'goalCareerInterest',
  combinedKey: 'careerAnyInterest',
  combinedKeyAnd: 'careerAnyInterestAnd',
};

export const COLLEGE_FILTER_KEYS = {
  nonFilterKey: 'heSchoolInterestList',
  nonFilterKeyAnd: 'heSchoolInterestListAnd',
  favoriteOnlyKey: 'heSchoolFavorite',
  favoriteOnlyKeyAnd: 'heSchoolFavoriteAnd',
  favoriteConditionKey: 'isFavoriteCollegeInterest',
  goalOnlyKey: 'heSchoolGoal',
  goalOnlyKeyAnd: 'heSchoolGoal',
  goalConditionKey: 'goalCollegeInterest',
  combinedKey: 'heSchoolAnyInterest',
  combinedKeyAnd: 'heSchoolAnyInterestAnd',
};

export const COMPLEX_FILTER_KEY = 'complexFilter';

export const STUDENT_LIST_DATA_TABLE_ID = 'studentList';
